import { Stack, styled, Typography } from '@planne-software/uni/mui/material';

// Override the uni ScopedCssBaseline defaults so the badges inherit the
// host page background and use the Work Sans font from the Figma design.
export const Wrapper = styled('div')({
  '.MuiScopedCssBaseline-root': {
    background: 'inherit',
    '*': {
      fontFamily: "'Work Sans', sans-serif",
    },
  },
});

export const Container = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  backgroundColor: theme.tokens.colors['fill-color-neutral-softest'],
  borderRadius: theme.tokens.radius['border-radius-2xs'],
  padding: theme.tokens.spacing['spacing-1xmini'],
  gap: theme.tokens.spacing['spacing-2xmini'],
}));

export const BadgeRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: theme.tokens.spacing['spacing-1xmini'],
}));

export const BadgeContent = styled(Stack)({
  flexDirection: 'column',
});

export const BadgeTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography['text-sm-semibold'],
  color: theme.tokens.colors['text-color-neutral-strongest'],
}));

export const BadgeDescription = styled(Typography)(({ theme }) => ({
  ...theme.typography['text-sm-regular'],
  color: theme.tokens.colors['text-color-neutral-strongest'],
}));
